import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BuildingIcon, ChevronDownIcon, PanelLeftCloseIcon, PanelLeftOpenIcon, SearchIcon } from 'lucide-react';
import { useDatos } from '../../contexts/DatosContext';
import { Avatar } from '../ui/Etiquetas';
import { MarcaGoogle } from '../ui/Google';
import { inicialesDe } from '../../data/abogados';
import type { Rol } from '../../types';
import { capitalizar, fechaLarga, HOY } from '../../utils/fechas';
import { format } from 'date-fns';
const ROLES: Rol[] = ['Administrador', 'Abogado', 'Recepción/Archivo'];
export function BarraSuperior({
  barraVisible,
  onAlternarBarra
}: {
  barraVisible: boolean;
  onAlternarBarra: () => void;
}) {
  const {
    sucursalActiva,
    setSucursalActiva,
    rol,
    setRol,
    sucursales,
    abogados,
    usuarioActualId,
    conexionGoogleDe
  } = useDatos();
  const navigate = useNavigate();
  const yo = abogados.find(a => a.id === usuarioActualId);
  const conexion = conexionGoogleDe(usuarioActualId);
  return <header className="sticky top-0 z-10 flex h-16 items-center gap-4 border-b border-gris-200 bg-white px-6" data-id="element-869" data-mp="2v7ktppd4alo9">
      <button type="button" onClick={onAlternarBarra} aria-expanded={barraVisible} aria-label={barraVisible ? 'Ocultar menú lateral' : 'Mostrar menú lateral'} title={barraVisible ? 'Ocultar menú lateral' : 'Mostrar menú lateral'} className="flex h-9 w-9 shrink-0 items-center justify-center rounded border border-gris-200 text-gris-500 transition-colors duration-150 hover:border-marino-300 hover:text-marino-700" data-id="element-870" data-mp="305w2dwroeq4w">
        {barraVisible ? <PanelLeftCloseIcon className="h-4 w-4" data-id="element-871" data-mp="3nvgoupn1g5ix" /> : <PanelLeftOpenIcon className="h-4 w-4" data-id="element-872" data-mp="3sua5us1jaenu" />}
      </button>

      <button type="button" onClick={() => navigate('/expedientes')} className="flex h-9 flex-1 max-w-md items-center gap-2 rounded border border-gris-200 bg-gris-50 px-3 text-left text-sm text-gris-500 transition-colors duration-150 hover:border-gris-300 hover:bg-white" data-id="element-873" data-mp="1th600h6g1bd5">
        <SearchIcon className="h-4 w-4" aria-hidden="true" data-id="element-874" data-mp="1mdzhztj74x5b" />
        Buscar por localizador, cliente o número de expediente…
      </button>

      <p className="hidden text-xs text-gris-500 xl:block" data-id="element-875" data-mp="20ea8uwkiabqh">
        {capitalizar(fechaLarga(format(HOY, 'yyyy-MM-dd')))}
      </p>

      <label className="relative flex items-center" data-id="element-876" data-mp="1vgqw613gi70n">
        <span className="sr-only" data-id="element-877" data-mp="29d42qf6gco0c">Sucursal</span>
        <BuildingIcon className="pointer-events-none absolute left-2.5 h-4 w-4 text-gris-400" aria-hidden="true" data-id="element-878" data-mp="29bt04ioqtmat" />
        <select value={sucursalActiva} onChange={e => setSucursalActiva(e.target.value)} className="h-9 appearance-none rounded border border-gris-200 bg-white pl-8 pr-8 text-sm font-medium text-gris-700" data-id="element-879" data-mp="2j48jnkfouixt">
          <option value="todas" data-id="element-880" data-mp="2t01yjagvqoir">Todas las sucursales</option>
          {sucursales.filter(s => s.activa).map(s => <option key={s.id} value={s.id} data-id="element-881" data-mp="37oli6oekwps6">
                {s.nombre}
              </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-2.5 h-4 w-4 text-gris-400" aria-hidden="true" data-id="element-882" data-mp="3bpx3ihqf6ouk" />
      </label>

      <div className="flex items-center gap-3 border-l border-gris-200 pl-4" data-id="element-883" data-mp="32p8xa979pss8">
        <button type="button" onClick={() => navigate('/mi-cuenta')} title="Abrir mi cuenta" className="rounded-full ring-offset-2 transition-opacity duration-150 hover:opacity-80" data-id="element-884" data-mp="2o0w2hfjx2fzb">
          <span className="sr-only" data-id="element-885" data-mp="2f18yclzsyw2k">Mi cuenta</span>
          <Avatar iniciales={inicialesDe(yo?.nombre ?? 'NN')} foto={yo?.foto} nombre={yo?.nombre} tamano="md" data-id="element-886" data-mp="2eycyut8b3zc0" />
        </button>
        <label className="leading-tight" data-id="element-887" data-mp="254381fz0j93e">
          <button type="button" onClick={() => navigate('/mi-cuenta')} className="flex items-center gap-1.5 text-xs font-semibold text-gris-800 hover:text-marino-700" data-id="element-888" data-mp="2a1mjk84bt7rn">
            {yo?.nombre.replace(/^Lic\.\s*/, '') ?? 'Mi cuenta'}
            {conexion.estado === 'conectado' && <MarcaGoogle titulo={`Google Calendar conectado: ${conexion.correoGoogle}`} data-id="element-889" data-mp="33kw98n09kmtu" />}
          </button>
          <span className="sr-only" data-id="element-890" data-mp="2yl08cwmv5bii">Rol activo</span>
          <select value={rol} onChange={e => setRol(e.target.value as Rol)} className="-ml-0.5 block cursor-pointer border-none bg-transparent p-0 text-2xs text-gris-500 focus:ring-0" data-id="element-891" data-mp="2to9qc3ri05ug">
            {ROLES.map(r => <option key={r} value={r} data-id="element-892" data-mp="2fo8i238wlw4y">
                {r}
              </option>)}
          </select>
        </label>
      </div>
    </header>;
}